import React, { Component } from 'react';
import { get, post } from '../../util/api';
import {
	Checkbox,
	FormControlLabel,
	Table,
	TableBody,
	TableCell,
	TableRow,
	TableHead,
	Box,
	TableContainer,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	RadioGroup,
	Radio,
	FormControlLabel as RadioLabel,
} from '@mui/material';

import _ from 'lodash';
// eslint-disable-next-line
import styled from 'styled-components/macro';

export default class Footprint extends Component {
	state = {
		loading: true,
		activePage: 1,
		limit: 500,
		email: '',
		active: true,
		multi: true,
		buttonloading: true,
		bannedList: [],
		openBanDialog: false,
		selectedNumber: null,
		banReason: 'trial-abuse',
		notBanned: true,
	};

	componentDidMount() {
		this.postData();
		this.fetchBannedList();
	}

	async fetchBannedList() {
		try {
			const response = await get('/maytapi/admin/bannedList');
			this.setState({ bannedList: response });
		} catch (error) {
			console.error('Error fetching banned list:', error);
		}
	}

	async postData() {
		var i;
		let myA = [],
			arr = [];
		let mGeneral = [];
		for (i = 0; i < 1; i++) {
			myA.push(i);
			arr.push(
				get(`/maytapi/admin/footprint/phone`).then((temp) => {
					let { success, result } = temp;
					let map_num = [];
					let general = {
						number: 0,
						account: 0,
						accounts: [],
						paid_account: 0,
						paid_number: 0,
					};
					let paids = ['api'];
					if (success) {
						map_num = _.map(result, ({ number, data }) => {
							let c = data.length;
							let last = data[parseInt(c) - 1];
							let active = last.status === 'active';
							if (paids.indexOf(last.package) !== -1) general.paid_number++;
							let detail = {
								data: _.map(data, ({ pid, status, email, package: _package }) => {
									general.accounts.push(pid);
									if (paids.indexOf(_package) !== -1) general.paid_account++;
									return (
										<div style={{ display: 'flex' }}>
											<span style={{ minWidth: 250 }}>{email}</span>
											<span style={{ minWidth: 250 }}>{status}</span>
											<span>{_package}</span>
										</div>
									);
								}),
								c,
							};
							return { number, detail, active, count: c };
						});
						general.number = map_num.length;
						general.account = _.uniq(general.accounts).length;
						delete general.accounts;
						mGeneral.push(general);
						return _.orderBy(map_num, 'number');
					}
				})
			);
		}
		myA = await Promise.all(arr);
		console.log(mGeneral);
		this.setState({
			list: _.flattenDeep(myA),
			general: {
				account: _.sumBy(mGeneral, 'account'),
				number: _.sumBy(mGeneral, 'number'),
				paid_account: _.sumBy(mGeneral, 'paid_account'),
				paid_number: _.sumBy(mGeneral, 'paid_number'),
			},
			loading: false,
			buttonloading: false,
		});
	}

	handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

	handleSort = (clickedColumn) => () => {
		const { column, list, direction } = this.state;

		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				list: _.sortBy(list, [clickedColumn]),
				direction: 'ascending',
			});
		} else {
			this.setState({
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		}
	};

	handleChange = (e, { name, value }) => {
		console.log(name, value.trim());
		if (name === 'activePage' && value < 1) {
			value = 1;
		}
		if (name === 'email') {
			value = value.trim();
		}
		this.setState({ [name]: value });
	};

	handleChangeToggle = (e) => {
		const { name } = e.target;
		this.setState((prevState) => ({ [name]: !prevState[name] }));
	};
	handleOpenBanDialog = (number) => {
		this.setState({ openBanDialog: true, selectedNumber: number });
	};

	handleCloseBanDialog = () => {
		this.setState({ openBanDialog: false, selectedNumber: null, banReason: 'trial-abuse' });
	};

	handleBanReasonChange = (event) => {
		this.setState({ banReason: event.target.value });
	};

	handleSetBan = async () => {
		const { selectedNumber, banReason } = this.state;
		try {
			await post('/maytapi/admin/setBan', { number: selectedNumber, reason: banReason });
			await this.fetchBannedList(); // Refresh the banned list
			this.handleCloseBanDialog();
		} catch (error) {
			console.error('Error setting ban:', error);
		}
	};
	handleOpenRemoveBanDialog = (number) => {
		this.setState({ openRemoveBanDialog: true, selectedNumber: number });
	};

	handleCloseRemoveBanDialog = () => {
		this.setState({ openRemoveBanDialog: false, selectedNumber: null });
	};

	handleRemoveBan = async () => {
		const { selectedNumber } = this.state;
		try {
			await post('/maytapi/admin/deleteBan', { number: selectedNumber });
			await this.fetchBannedList(); // Refresh the banned list
			this.handleCloseRemoveBanDialog();
		} catch (error) {
			console.error('Error removing ban:', error);
		}
	};
	render() {
		const { column, list, direction, loading, general, active, multi, bannedList, openBanDialog, banReason, notBanned, openRemoveBanDialog } = this.state;
		if (loading) return <Box attached="bottom">loading...</Box>;

		let newlist = _.sortBy(
			_.filter(
				_.filter(list, (it) => (active ? it.active === active : true)),
				(it) => (multi ? it.count > 1 : true)
			),
			column
		);
		if (direction === 'descending') {
			newlist = newlist.reverse();
		}

		return (
			<Box attached="bottom">
				<div
					style={{ marginBottom: '15px' }}
					css={`
						display: flex;
						> div {
							span {
								font-weight: bold;
								text-transform: capitalize;
							}
							margin-right: 5px;
							padding: 6px 12px;
							border: 1px solid #ccc;
							border-radius: 3px;
						}
					`}
				>
					{_.map(general, (value, key) => (
						<div key={key}>
							<span>{key.replace(/_/g, ' ')}</span>: {value}
						</div>
					))}
					<FormControlLabel control={<Checkbox checked={active} name="active" onChange={this.handleChangeToggle} />} label="Only Active" />
					<FormControlLabel control={<Checkbox checked={multi} name="multi" onChange={this.handleChangeToggle} />} label="Only Multiple" />
					<FormControlLabel control={<Checkbox checked={notBanned} name="notBanned" onChange={this.handleChangeToggle} />} label="Not Banned" />
				</div>
				<TableContainer>
					<Table stickyHeader>
						<TableHead>
							<TableRow>
								<TableCell onClick={this.handleSort('number')}>Number</TableCell>
								<TableCell >Detail</TableCell>
								<TableCell onClick={this.handleSort('active')}>Active</TableCell>
								<TableCell onClick={this.handleSort('count')}>Count</TableCell>
								<TableCell onClick={this.handleSort('banned')}>Banned</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{_.map(newlist, ({ number, detail, active }) => {
								const isBanned = _.find(bannedList, (it) => it.number === number);
								if (notBanned && isBanned) return console.log(number, isBanned && isBanned.reason);
								return (
									<TableRow key={number}>
										<TableCell>{number}</TableCell>
										<TableCell>{detail.data}</TableCell>
										<TableCell>{active ? '✔' : '⨉'}</TableCell>
										<TableCell>{detail.c.toString()}</TableCell>
										<TableCell>{isBanned ? `Banned - ${isBanned.reason}` : '-'}</TableCell>
										<TableCell>
											<Button variant="contained" color="secondary" onClick={() => this.handleOpenBanDialog(number)}>
												Set Ban
											</Button>
											{isBanned && (
												<Button variant="contained" color="primary" onClick={() => this.handleOpenRemoveBanDialog(number)}>
													Remove Ban
												</Button>
											)}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<Dialog open={openBanDialog} onClose={this.handleCloseBanDialog}>
					<DialogTitle>Set Ban</DialogTitle>
					<DialogContent>
						<RadioGroup value={banReason} onChange={this.handleBanReasonChange}>
							<RadioLabel value="trial-abuse" control={<Radio />} label="Trial Abuse" />
							<RadioLabel value="banned" control={<Radio />} label="Banned" />
						</RadioGroup>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCloseBanDialog}>Cancel</Button>
						<Button onClick={this.handleSetBan} color="primary">
							Confirm
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog open={openRemoveBanDialog} onClose={this.handleCloseRemoveBanDialog}>
					<DialogTitle>Remove Ban</DialogTitle>
					<DialogContent>Are you sure you want to remove the ban for this number?</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCloseRemoveBanDialog}>Cancel</Button>
						<Button onClick={this.handleRemoveBan} color="primary">
							Confirm
						</Button>
					</DialogActions>
				</Dialog>
			</Box>
		);
	}
}
